import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    width: 480,
};

const tableWidthSlice = createSlice({
    name: 'tableWidth',
    initialState,
    reducers: {
        changeWidth: (state, action) => {
            state.width = action.payload;
        },
    },
});

export const { actions: tableWidthActions } = tableWidthSlice;
export const { reducer: tableWidthReducer } = tableWidthSlice;
